import { defineComponent, PropType } from "@vue/composition-api";
import { CreateElement, RenderContext, VNode } from "vue";
import { TranslateResult } from "vue-i18n";
import BaseImage from "@/components/BaseImage";

type Props = {
  imgSrc: string;
  imgAlt: string;
  text: string;
};

export default defineComponent({
  name: "EmptyContent",
  functional: true,
  props: {
    imgSrc: { type: String },
    imgAlt: { type: String },
    text: { type: String as PropType<TranslateResult>, default: "" },
  },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const { imgSrc, imgAlt, text } = ctx.props;

    return h(
      "div",
      {
        staticClass: "empty-content centered-content",
        class: [...(Array.isArray(ctx.data.class) ? ctx.data.class : [ctx.data.class]), ctx.data.staticClass],
      },
      [
        ctx.scopedSlots["prepend"] && ctx.scopedSlots["prepend"]({}),

        ctx.props.imgSrc && h(BaseImage, { class: "empty-content__image", props: { src: imgSrc, alt: imgAlt } }),

        (ctx.scopedSlots.default && ctx.scopedSlots.default({})) ||
          h("div", { class: { "mt-4": !!imgSrc }, staticClass: "px-4" }, [text]),

        ctx.scopedSlots["append"] && ctx.scopedSlots["append"]({}),
      ]
    );
  },
});
